module.exports = __webpack_public_path__ + "static/scale-model-of-minnie's-house-in-garden-grove-california-bd4e335bb6bee741744e691ca3ea7a39.png";